import { useMemo } from 'react'
import { montarBlocos, contarMudancas } from './diff-blocos.js'

/** Diff de linhas com a lib `diff` (zero dependencias). */
export function Diff({ anterior, atual, rotuloAnterior, rotuloAtual }) {
  const blocos = useMemo(() => montarBlocos(anterior ?? '', atual ?? ''), [anterior, atual])
  const { adicionadas, removidas, identico } = useMemo(() => contarMudancas(blocos), [blocos])

  return (
    <div className="diff">
      <div className="diff__cabecalho">
        <span className="diff__rotulo">
          {rotuloAnterior} → {rotuloAtual}
        </span>
        {identico ? (
          <span className="diff__resumo diff__resumo--igual">textos idênticos</span>
        ) : (
          <span className="diff__resumo">
            <span className="diff__mais">+{adicionadas}</span> <span className="diff__menos">−{removidas}</span>
          </span>
        )}
      </div>

      {identico ? (
        <p className="diff__vazio">Nada mudou entre as duas versões.</p>
      ) : (
        <div className="diff__corpo">
          {blocos.map((bloco, indice) =>
            bloco.omitidas ? (
              <div key={`omitidas-${indice}`} className="diff__omitidas">
                ⋯ {bloco.omitidas} linha(s) sem alteração
              </div>
            ) : (
              bloco.linhas.map((linha, posicao) => (
                <div key={`${indice}-${posicao}`} className={`diff__linha diff__linha--${linha.tipo}`}>
                  <span className="diff__sinal">
                    {linha.tipo === 'adicionada' ? '+' : linha.tipo === 'removida' ? '−' : ' '}
                  </span>
                  <span className="diff__texto">{linha.texto || ' '}</span>
                </div>
              ))
            ),
          )}
        </div>
      )}
    </div>
  )
}
